// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"333":"88a97103","390":"91e30b7b","453":"d630ec75","732":"6903ccb9","787":"b46f3556","811":"55d11f1f","960":"7a0f29d0"}[chunkId] + ".chunk.js";
};